import { URL } from '@jet/environment/util/urls';
import { Locale as LocaleUtil } from '~/utils/locale';

interface Locale {
    storefront: string;
    language: string | null;
}

// This should be a responsibility of Jet
export function buildUrl(
    path: string,
    locale: Locale,
    includeOrigin: boolean = true,
    includeStorefront: boolean = true,
): string {
    const { storefront, language, isDefaultLanguage } =
        LocaleUtil.normalize(locale);

    // Relative urls allows the url to appear in the context of the environent
    // in which the app is running (carry, stage, etc.).  Unless needed, prefer
    // to use relative urls over absolute urls.  Given the context of this
    // utility, it will default to setting a specific origin unless told otherwise.
    const origin = includeOrigin ? 'https://classical.music.apple.com' : '';

    const url = new URL(origin);

    if (includeStorefront) {
        url.path(storefront);
    }

    // Skip the leading / (if it is included you get a double //)
    // Don't do this if the path ends up being an empty string,
    // otherwise the result will include a trailing slash.
    if (path) {
        url.path(path.substr(1));
    }

    if (!isDefaultLanguage && language) {
        url.param('l', language.split('-')[0]);
    }

    return url.toString();
}
